import ConstantsImages from "../../../constants/ConstantsImages";
import ConstantsTexts from "../../../constants/ConstantsTexts";
import WidgetDropdown, { DropdownType } from "../widget-dropdown/WidgetDropdown";
import "./WidgetModelVersionDropdown.css";

const WidgetModelVersionDropdown = ({
  widthProp = "23.6rem",
  options = [],
  onSelect,
  selectedOptionProp,
  disabled = false,
  customFooterItemFirst = null,
  onCustomItemClickFirst = null,
  customFooterItemSecond = null,
  onCustomItemClickSecond = null,
  type = DropdownType.DEFAULT_SELECT,
  enableDelete = false,
  onDelete,
  backgroundColorProp = "#2E2E2E",
}) => {
  return (
    <div className="wmvd-frame-6" style={{ width: widthProp, backgroundColor: backgroundColorProp }}>
      <WidgetDropdown
        options={options}
        labelKey="model_version_display"
        onSelect={onSelect}
        selectedOptionProp={selectedOptionProp}
        title={ConstantsTexts.CODE_119}
        heightProp="6.2rem"
        backgroundColorProp={backgroundColorProp}
        titleColorProp="#fff"
        textColorProp="#fff"
        arrowImage={ConstantsImages.ARROW_WHITE_IMAGE}
        imageProp={ConstantsImages.MODEL_VERSION_IMAGE}
        fontSizeTitle="2rem"
        fontWeightTitle="900"
        fontSizeText="1.5rem"
        fontFamilyText="Almoni DL AAA"
        disabled={disabled}
        type={type}
        enableFrozenOptionDisplay={true}
        customFooterItemFirst={customFooterItemFirst}
        onCustomItemClickFirst={onCustomItemClickFirst}
        customFooterItemSecond={customFooterItemSecond}
        onCustomItemClickSecond={onCustomItemClickSecond}
        enableDelete={enableDelete}
        onDelete={onDelete}
      />
    </div>
  );
};

export default WidgetModelVersionDropdown;
